import InfoIcon from "@mui/icons-material/Info";
import { Box, Typography } from "@mui/material";
import useColors from "../../../../../api/hooks/useColors";
import CustomToolTip from "../../../../../components/CustomTooltip";
import SvgToIcon from "../../../../../icons/SvgToIcon";
const LabelInfoSection = ({ label, icon, infoData }) => {
  const colors = useColors();

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "row",
        gap: "4px",
        alignItems: "center",
      }}
    >
      <Box
        sx={{
          backgroundColor: colors.primary_8percent,
          display: "flex",
          flexDirection: "row",
          gap: "4px",
          padding: "0 8px",
          borderRadius: "8px",
        }}
      >
        <SvgToIcon
          IconLogo={icon}
          width="14px"
          style={{ color: colors.primary_main }}
        />
        <Typography
          variant="caption"
          sx={{
            color: colors.primary_main,
          }}
        >
          {label}
        </Typography>
      </Box>
      <CustomToolTip
        title={<Typography variant="caption">{infoData}</Typography>}
      >
        <InfoIcon
          sx={{
            color: colors.primary_24percent,
            width: "18px",
          }}
        />
      </CustomToolTip>
    </Box>
  );
};

export default LabelInfoSection;
